module.exports = __webpack_public_path__ + "static/Otzovik-1a7ffef524f2f8b5094a9c6560a43352.png";